module.exports = __webpack_public_path__ + "static/media/m_sf_16.80969f92.png";